import {
	caseApi,
	standardApi,
	labApi,
	assistanceApi,
	evaluationApi,
	surgeryApi,
	dischargeApi,
	caseUpdate,
	labUpdate,
	assistanceUpdate,
	evaluationUpdate,
	surgeryUpdate,
	dischargeUpdate,
	caseGet,
	labGet,
	evaluationGet,
	surgeryGet,
	dischargeGet,
	assistanceGet,
	getQuestionAPI,
	getOperationLogApi,
	clinicApi,
	clinicUpdate,
	clinicGet,
	followupGet,
	followupApi,
	followupUpdate,
	followup3Api,
	followup6Api,
	followup12Api,
	followupUpdate12,
	followupUpdate6,
	followupUpdate3,
	saveLockAPI,
	getLockAPI,
} from '@/api/mods/entryApi';
import { Form, message } from 'antd';
import log from 'loglevel';
import { useCallback, useState } from 'react';
import _ from 'lodash';
import { complicationControllerGet } from '@/services/ant-design-pro/complication';
import { visit1ControllerGet } from '@/services/ant-design-pro/visit1';
import { visit2ControllerGet } from '@/services/ant-design-pro/visit2';
import { visit3ControllerGet } from '@/services/ant-design-pro/visit3';
import { visit4ControllerGet } from '@/services/ant-design-pro/visit4';
import { visit5ControllerGet } from '@/services/ant-design-pro/visit5';
import { visit6ControllerGet } from '@/services/ant-design-pro/visit6';
import { visit7ControllerGet } from '@/services/ant-design-pro/visit7';
import { visit8ControllerGet } from '@/services/ant-design-pro/visit8';
import { pregnancyControllerGet } from '@/services/ant-design-pro/pregnancy';
import { summaryControllerGet } from '@/services/ant-design-pro/summary';
import { unplannedControllerGet } from '@/services/ant-design-pro/unplanned';
import { adverseControllerGet } from '@/services/ant-design-pro/adverse';
import { challengeControllerGet } from '@/services/ant-design-pro/challenge';
import {
	commonControllerGetLock,
	commonControllerGetOperationLog,
} from '@/services/ant-design-pro/common';
import { filterControllerGet } from '@/services/ant-design-pro/filter';

interface ApiType {
	data: any;
	apiName: string;
}

export const tabName = [
	'filter',
	'visit1',
	'visit2',
	'visit3',
	'visit4',
	'visit5',
	'visit6',
	'visit7',
	'visit8',
	'pregnancy',
	'complication',
	'adverse',
	'unplanned',
	'summary',
];

export default function EntryStoreModel() {
	const showMsg = {
		'en-US': 'Network request failed, please try later',
		'zh-CN': '网络请求失败，请稍后尝试或者联系管理员',
		'zh-TW': '网络请求失败，请稍后尝试或者联系管理员',
	};

	const [hubId, setHubId] = useState<string | number>(''); // form id
	const [entryAllData, setEntryAllData] = useState<Record<string, any>>({
		filter: null,
		visit1: null,
		visit2: null,
		visit3: null,
		visit4: null,
		visit5: null,
		visit6: null,
		visit7: null,
		visit8: null,
		complication: null,
		adverse: null,
		pregnancy: null,
		unplanned: null,
		summary: null,
	}); // 全部数据

	// 质疑info
	const [questionNumber, setQuestionNumber] = useState<Record<
		string,
		any
	> | null>(null);
	const [questionDatas, setQuestionDatas] = useState<any[]>([]);
	const [questionLog, setQuestionLog] = useState<Record<string, any>>({});
	const [questionIconClass, setQuestionIconClass] = useState<
		Record<string, string>
	>({});
	const [questionPdf, setQuestionPdf] = useState<Record<string, any>>({});

	// 操作日志
	const [operationLog, setOperateLog] = useState<
		Record<string, Record<string, string | number | string[]>[]>
	>({});

	const [operationLogPdf, setOperationLogObj] = useState<
		Record<string, Record<string, string | number | string[]>[]>
	>({});

	// 加载提示tabs
	const [tableSpin, setTableSpin] = useState<boolean>(false);

	// 锁定
	const [getLock, setGetLock] = useState<Record<string, boolean>>({});

	// get entry
	const getEntryData = async (id: number, isReturned: boolean = false) => {
		try {
			setTableSpin(true);
			const allParams = tabName;
			const data: any = {};
			if (isReturned) {
				const filters = await filterControllerGet({ hubId: id });

				setEntryAllData({
					filter: filters.data,
				});
				setTableSpin(false);
				return;
			}
			const result = await Promise.allSettled([
				await filterControllerGet({ hubId: id }),
				await visit1ControllerGet({ hubId: id }),
				await visit2ControllerGet({ hubId: id }),
				await visit3ControllerGet({ hubId: id }),
				await visit4ControllerGet({ hubId: id }),
				await visit5ControllerGet({ hubId: id }),
				await visit6ControllerGet({ hubId: id }),
				await visit7ControllerGet({ hubId: id }),
				await visit8ControllerGet({ hubId: id }),
				await pregnancyControllerGet({ hubId: id }),
				await complicationControllerGet({ hubId: id }),
				await adverseControllerGet({ hubId: id }),
				await unplannedControllerGet({ hubId: id }),
				await summaryControllerGet({ hubId: id }),
			]);

			result.forEach((ApiStatus: any, index) => {
				// 如果ApiStatus.value.data 是 null 或者空数组 则设置为 {}
				data[allParams[index]] = ApiStatus.value.data;
				// setEntryAllData(data);
			});
			setEntryAllData(data);
			setTableSpin(false);

			return data;
		} catch (e) {
			log.error('getEntry:', e);
			setTableSpin(false);
			return false;
		}
	};

	// get question List
	const getQuestionDatas = async (id: string) => {
		try {
			const data = await challengeControllerGet({ hubId: Number(id) });

			const questionIconType = {};
			const tabs: Record<string, any> = {};
			const pdf: Record<string, any> = {};
			data.forEach((item: any, index: number) => {
				// eslint-disable-next-line no-param-reassign
				item.key = index;
				if (item.entityId) {
					const currObj = {};
					const filterData = data?.filter(
						(o: { entityId: string }) => o.entityId === item.entityId
					);

					tabs[item.entityId] = filterData;
					filterData.forEach((i: { property: string | number }) => {
						currObj[i.property] = i;
					});
					pdf[item.entityId] = currObj;
					return;
				}

				tabs[_.toLower(item.entity)] = data?.filter(
					(o: { entity: string }) => o.entity === item.entity
				);

				pdf[item.property] = item;
			});
			const info = {};
			console.log(data, 'data');
			setQuestionLog(tabs);
			Object.keys(tabs).forEach((key) => {
				const item = tabs[key];
				const property = {};
				//@ts-ignore
				info[key] = handleQuestionNumber(item);

				item.forEach(
					(e: {
						propertyId?: number;
						isDone: boolean;
						property: string | number;
						talk: string | any[];
						entityId?: string;
					}) => {
						if (e.propertyId) {
							if (e.isDone) {
								property[e.propertyId] = {
									type: 'DONE',
									id: e.property,
									propertyId: e.propertyId,
								};
								return;
							}
							property[e.propertyId] = {
								type: e.talk[e.talk.length - 1].type,
								id: e.property,
								propertyId: e.propertyId,
							};
							return;
						}
						if (e.isDone) {
							property[e.property] = 'DONE';
							return;
						}
						property[e.property] = e.talk[e.talk.length - 1].type;
					}
				);

				questionIconType[key] = property;
			});
			setQuestionDatas(data);
			setQuestionNumber(info);
			setQuestionIconClass(questionIconType);
			setQuestionPdf(pdf);
		} catch (e) {
			log.info(e);
		}
	};

	const resetStateFunc = () => {
		setQuestionIconClass({});
		setQuestionNumber(null);
		setEntryAllData({
			visit1: null,
			visit2: null,
			visit3: null,
			visit4: null,
			visit5: null,
			visit6: null,
			visit7: null,
			visit8: null,
			complication: null,
			adverse: null,
			pregnancy: null,
			unplanned: null,
			summary: null,
		});
		setGetLock({});
	};

	const handleQuestionNumber = (
		data: { isDone: boolean; talk: string | any[] }[]
	) => {
		const DONE = [];
		const QUESTION = [];
		const ANSWER = [];
		const info: Record<string, number | null> = {
			done: null,
			question: null,
			answer: null,
		};
		data.forEach((item) => {
			if (item.isDone) {
				DONE.push(item);
				return;
			}
			if (item.talk) {
				if (item.talk[item.talk.length - 1].type === 'ANSWER') {
					ANSWER.push(item);
				} else {
					QUESTION.push(item);
				}
			}
		});
		info.done = DONE.length ? DONE.length : null;
		info.question = QUESTION.length ? QUESTION.length : null;
		info.answer = ANSWER.length ? ANSWER.length : null;
		return info;
	};

	// 获取操作日志
	const getOerationLog = async (id: string) => {
		try {
			const data = await commonControllerGetOperationLog({ hubId: Number(id) });
			const obj = {};
			tabName.forEach((key) => {
				// @ts-ignore
				obj[key] = data?.filter((o: any, index: number) => {
					o.key = index;
					return o.entity === _.toUpper(key);
				});
			});
			setOperateLog(obj);

			//@ts-ignore
			setOperationLogObj(_.groupBy(data, 'property'));

			setTableSpin(false);
		} catch (e) {
			setTableSpin(false);
			log.info(e);
		}
	};

	// // saver Entry
	// const updateEntryData = async ({ data, apiName }: ApiType) => {
	//   try {
	//     const res = await apiProxyUpdate[apiName](data);
	//     await getOerationLog(data.hubId);
	//     await getQuestionDatas(data.hubId);
	//     return res.data;
	//   } catch (e) {
	//     log.error("errorUpdate:", e);
	//     message.error(showMsg[locale]);
	//     return null;
	//   }
	// };

	// lock
	const saveLock = async (param: {
		hubId: number;
		entity: string;
		entityId?: string;
		isLock: boolean;
	}) => {
		try {
			return await saveLockAPI(param);
		} catch (e) {
			log.info(e);
			return e;
		}
	};

	const getLockApi = async (id: string) => {
		try {
			// @ts-ignore
			const res = await commonControllerGetLock({ hubId: Number(id) });

			// 转换 res key 变成小写
			setGetLock(_.mapKeys(res, (value, key) => _.toLower(key)));
		} catch (e) {
			log.info(e);
		}
	};
	return {
		hubId,
		// updateEntryData,
		getEntryData,
		getQuestionDatas,
		getOerationLog,
		setHubId,
		entryAllData,
		setEntryAllData,
		questionDatas,
		questionNumber,
		questionIconClass,
		operationLog,
		tableSpin,
		operationLogPdf,
		questionPdf,
		saveLock,
		getLockApi,
		getLock,
		setTableSpin,
		questionLog,
		resetStateFunc,
	};
}
